import React from 'react';

import css from './PressKit.module.scss';

import data from './data.json';

const PressKit = () => {
	return (
		<section className={css.pressKit}>
			<h4 className="textGreen">Press Kit</h4>
			<div className={css.contentWrapper}>
				<div className={css.cards}>
					{data.map(({ heading, description, downloadLink }) => (
						<div className={css.card}>
							<h5>{heading}</h5>
							<p>{description}</p>
							<a href={downloadLink}>Download Link</a>
						</div>
					))}
				</div>
				<div className={css.email}>
					For press communication, contact{' '}
					<a href="mailto:press@moneyfront.in">press@moneyfront.in</a>
				</div>
			</div>
		</section>
	);
};

export default PressKit;
